import { Button } from "primereact/button";

/**
 * Get tooltip position based on the button position
 * @param {string} position
 */
const getTooltipPosition = (position) => {
  switch (position) {
    case "bottom-right":
      return "left";
    case "bottom-left":
      return "right";
    case "top-right":
      return "left";
    case "top-left":
      return "right";
    default:
      return "top";
  }
};

/**
 * Botón flotante
 * @param {object} props
 * @param {() => void} props.onClick - Función a ejecutar al hacer clic en el botón
 * @param {string} [props.label=""]
 * @param {string} [props.icon=""]
 * @param {"bottom-right" | "bottom-left" | "top-right" | "top-left"} [props.position="bottom-right"] - Posición del botón flotante
 * @param {string} [props.tooltip=""] - Texto del tooltip
 * @param {boolean} [props.disabled=false] - Si el botón está deshabilitado
 */
export default function FloatingButton({
  onClick,
  label = "",
  icon = "",
  position = "bottom-right",
  tooltip = "",
  disabled = false,
}) {
  return (
    <Button
      label={label}
      icon={icon}
      rounded
      raised
      className="fixed"
      disabled={disabled}
      onClick={onClick}
      style={{
        bottom: position.includes("bottom") ? "2.25rem" : "auto",
        top: position.includes("top") ? "1.5rem" : "auto",
        right: position.includes("right") ? "1.75rem" : "auto",
        left: position.includes("left") ? "1.75rem" : "auto",
      }}
      {...(tooltip !== ""
        ? {
            tooltip,
            tooltipOptions: { position: getTooltipPosition(position) },
          }
        : {})}
    />
  );
}
